import { $authHost } from "."

/**
 * Преобразует Date объект в строку формата YYYY-MM-DD
 */
function formatDate(date) {
    if (!date) return null
    if (typeof date === 'string') return date
    const d = new Date(date)
    const year = d.getFullYear()
    const month = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
}

export default async function getStat(start, end) {
    try {
        const startDate = formatDate(start)
        const endDate = formatDate(end)
        const { data } = await $authHost.get('/api/statistic', {
            params: {
                start: startDate,
                end: endDate
            }
        })
        
        return data
    } catch(e) {
        console.log(e)
    }
}

export async function getXlsx(start, end) {
    try {
        const startDate = formatDate(start)
        const endDate = formatDate(end)
        const data = await $authHost.get('/api/statistic/xlsx', {
            params: {
                start: startDate,
                end: endDate
            },
            responseType: 'blob',
        })
        console.log(data)
        return data
    } catch(e) {
        console.log(e)
    }
}

/**
 * Получить статистику для одного хоста
 */
export async function getSingleStat(start, end, host) {
    try {
        const startDate = formatDate(start)
        const endDate = formatDate(end)
        const { data } = await $authHost.get(`/api/statistic/${encodeURIComponent(host)}`, {
            params: {
                start: startDate,
                end: endDate
            }
        })
        return data
    } catch(e) {
        console.log(e)
        return null
    }
}